import { render, staticRenderFns } from "./ItineraryDescription.vue?vue&type=template&id=76bb78e8&scoped=true&"
import script from "./ItineraryDescription.vue?vue&type=script&lang=js&"
export * from "./ItineraryDescription.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryDescription.vue?vue&type=style&index=0&id=76bb78e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bb78e8",
  null
  
)

export default component.exports